/** Split resume extracted text into plain text and http(s) URL segments. */

export function resumeTextHasExternalLinks(text) {
  return typeof text === "string" && /https?:\/\//i.test(text);
}

export function stripTrailingUrlPunctuation(url) {
  if (typeof url !== "string") return "";
  return url.replace(/[.,);:!?\]]+$/g, "");
}

export function splitResumeTextWithLinks(text) {
  if (typeof text !== "string" || !text) return [];

  const parts = text.split(/(https?:\/\/[^\s<>"']+)/gi);
  return parts.map((part, index) => {
    const isLink = /^https?:\/\//i.test(part);
    return {
      key: `resume-segment-${index}`,
      type: isLink ? "link" : "text",
      value: part,
    };
  });
}
